// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { Component, Host, Prop, State, h } from '@stencil/core';

import { AffiliateControllerResponse } from '../../../../types/controllers/affiliate';
import { DeviceType } from '../../components';
import { BannerPromotion } from '../../types';
import { ageClass } from '../../utils/age-check';
import { getPlacement } from '../../utils/api';
import { getPromos } from '../bam-banner/utils';

@Component({
    tag: 'banner-image',
    styleUrl: 'banner-image.css',
    shadow: true,
})
export class BannerImage {
    private defaultCallback() {
        return null;
    }

    @Prop() propertyId: number;
    @Prop() placementId: number;
    @Prop() context: string;
    @Prop({ mutable: true }) canUseAlternateLink: boolean;
    @Prop() baseEventOptions: any;
    @Prop() callback: () => void = this.defaultCallback;

    // optional characteristics props
    @Prop({ mutable: true }) location: string;
    @Prop() pageSlug: string;
    @Prop() subscriptionTier: 0 | 1 | 2 | 3;
    @Prop() wasPro: boolean;
    @Prop() subdivision: number;
    @Prop() league: string;
    @Prop() gameId: number;
    @Prop() ctaType: string;
    @Prop() isMobile: boolean;
    @Prop() deviceType: DeviceType;
    @Prop() isBetsyncUser: boolean;
    @Prop() parentWidth: number;
    @Prop() userParentBookIds: string;
    @Prop() isLoggedIn: boolean;
    @Prop() sponsorSlug: string;

    // optional props for functionality
    @Prop() defer: boolean;
    @Prop() rotate: boolean;
    @Prop() rotateTime: number;
    @Prop() devMode = false;
    @Prop() age: number;
    @Prop() hideUnderage = false;

    @State() promotions: Array<BannerPromotion>;

    connectedCallback() {
        getPlacement(
            {
                placement_id: this.placementId,
                property_id: this.propertyId,
                location: this.location,
                page_slug: this.pageSlug,
                subscription_tier: this.subscriptionTier,
                was_pro: this.wasPro,
                subdivision_id: this.subdivision,
                league: this.league,
                game_id: this.gameId,
                cta_type: this.ctaType,
                is_mobile: this.isMobile,
                device_type: this.deviceType,
                isBetsyncUser: this.isBetsyncUser,
                user_parent_book_ids: this.userParentBookIds ? this.userParentBookIds.split(',').map(Number) : [],
                is_logged_in: this.isLoggedIn,
                sponsor_slug: this.sponsorSlug,
                context: this.context,
            },
            this.setNewPromosToState.bind(this),
            this.devMode,
            'Banner'
        );
    }

    setNewPromosToState(placement: AffiliateControllerResponse): void {
        const filteredPromotions = getPromos(placement);
        const location = placement.location;
        const canUseAlternateLink = placement.allow_alternate_link;

        if (!filteredPromotions.length) {
            // eslint-disable-next-line no-console
            console.warn('BAM BANNER ERROR: No active promotions or promotions with banner images returned');
            this.promotions = filteredPromotions;
            return;
        }

        this.promotions = filteredPromotions;
        this.location = location;
        this.canUseAlternateLink = canUseAlternateLink;
    }

    render() {
        return this.promotions ? (
            <Host class={ageClass(this.age, this.promotions, this.hideUnderage)}>
                {this.rotate && this.promotions.length > 1 && this.rotate ? (
                    <rotating-banner
                        parent-width={this.parentWidth}
                        promotions={this.promotions}
                        propertyId={this.propertyId}
                        context={this.context}
                        location={this.location}
                        can-use-alternate-link={this.canUseAlternateLink}
                        eventOptions={this.baseEventOptions}
                        rotateTime={this.rotateTime}
                        callback={this.callback}
                    ></rotating-banner>
                ) : (
                    <static-banner
                        parent-width={this.parentWidth}
                        promotion={this.promotions[0]}
                        property-id={this.propertyId}
                        context={this.context}
                        location={this.location}
                        can-use-alternate-link={this.canUseAlternateLink}
                        eventOptions={{
                            ...this.baseEventOptions,
                            allPromotions: this.promotions,
                        }}
                        callback={this.callback}
                    ></static-banner>
                )}
            </Host>
        ) : null;
    }
}
